<div class="ui button primary outlined icon-button" (click)="toggleDropdown()">
  <i class="eye icon" title="View Controls"></i>
  <span class="text">{{ "taxReturns.view-controls" | transloco }}</span>
</div>

<div #tableViewControls id="table-view-controls-modal" class="ui tiny modal">
  <div class="icon modal-close close"></div>

  <h1>{{ "taxReturns.view-controls" | transloco }}</h1>

  <div class="modal-body">
    <div class="column-listing">
      @for (question of questions; track question) { @if (!question.hidden) {
      <label class="item" title="{{ question.question }}">
        <input
          class="ui checkbox"
          type="checkbox"
          [(ngModel)]="isColumnVisible[question.id]"
        />
        &nbsp; <span>{{ question.id }}.</span> {{ question.question }}
      </label>
      } }
    </div>

    <div>
      <div class="action-buttons">
        <div class="action-buttons-left">
          <div class="ui button primary outlined" (click)="resetToShowAll()">
            {{ "taxReturns.show-all" | transloco }}
          </div>
        </div>
        <div class="actions">
          <div class="ui button primary" (click)="applyViewControls()">
            {{ "taxReturns.apply" | transloco }}
          </div>
          <div class="ui button primary outlined cancel">
            {{ "taxReturns.cancel" | transloco }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
